import React, { useState, useCallback, useEffect } from 'react';
import { GoogleMap, MarkerF, useJsApiLoader, InfoWindowF, Circle, CircleF, OverlayView, OverlayViewF } from '@react-google-maps/api';
import RecipeReviewCard from './Component/Mcard';
import axios from 'axios';
import { Chip, Drawer } from '@mui/material';
import Form from './Component/Form';
import FaceIcon from '@mui/icons-material/Face';

const containerStyle = {
  width: '100vw',
  height: '100vh',
}

const center = {
  lat: 10,
  lng: 40,
};

function MyComponent() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCtIGX5DjROORcpJAo8fNh2TD7S67FcVvM',
  });

  const [markers, setMarkers] = useState([center,]); // Store all markers
  const [selectedPosition, setSelectedPosition] = useState([]);

  const onLoad = useCallback((map) => {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
  }, []);

  const onUnmount = useCallback(() => {
  }, []);

  // Capture map clicks and add a new marker
  const handleMapClick = (event) => {
    const newMarker = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
    setState(true)
    setMarkers((current) => [...current, newMarker]); // Add new marker to markers array
  };

  const [infoWindowVisible, setInfoWindowVisible] = useState(false);
  
  const handleMarkerClick = (marker) => {
    setSelectedPosition(marker);
    setInfoWindowVisible(true);
  };

  const handleInfoWindowClose = () => {
    setInfoWindowVisible(false);
    setSelectedPosition(null);
  };
  
  const [apifeatch, setApifeatch] = useState([]); // Initialize state for API data

   useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://outreach-mapping-tool-1.onrender.com/form/getReachedPeoples');
        setApifeatch(response.data); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData(); // Call the fetch function
  }, []);
  console.log(selectedPosition)
  const [state, setState] = React.useState(false); // Set initial state to false for Drawer

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState(open); // Correctly update the state
  };
  console.log(apifeatch)
  return isLoaded ? (
 <>
  <Drawer
            anchor={"left"} // Drawer opens from the left
            open={state}
            onClose={toggleDrawer(false)}
          >
        <div className='w-[500px]'>
<Form/>
        </div>
          </Drawer>
          <GoogleMap
            id="google-map-script"
            className="map"
            mapElement={null}
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
            onClick={handleMapClick} // Capture clicks on the map
            options={{
              // streetViewControl: false,
              // mapTypeControl: false,
              //  mapTypeId: 'satellite'
    
            }}
          >
            {/* Render each marker */}
            {markers?.map((marker, index) => (
              <MarkerF
             
                key={index}
                position={marker}
                onClick={() => handleMarkerClick(marker)}
              />
             
            ))}
      {apifeatch?.map((pinmarker, index) => (
        pinmarker.location.type==="Circle"?
        <>
        <CircleF
        center={{
          lat: parseFloat(pinmarker.location.coordinates[0]),
          lng: parseFloat(pinmarker.location.coordinates[1]),
        }}
        onClick={() => handleMarkerClick(pinmarker)}
        radius={10000} // Radius in meters
        options={{
          fillColor: `${pinmarker.evangelismMethod==='oneToOneOutreach'?'#0066FFFF':'#00FF00'}` , // Green color
          fillOpacity: 0.5,
          strokeColor: `${pinmarker.evangelismMethod==='oneToOneOutreach'?'#0066FFFF':'#00FF00'}`,
          strokeOpacity: 0.8,
          strokeWeight: 2,
        }}
      />
       <OverlayViewF
        position={{
          lat: parseFloat(pinmarker.location.coordinates[0]),
          lng: parseFloat(pinmarker.location.coordinates[1]),
        }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        onClick={() => handleMarkerClick(pinmarker)}
      >
        <span class="relative flex h-5 w-5">
  <span class={`animate-ping absolute inline-flex h-full w-full rounded-full ${pinmarker.evangelismMethod==='oneToOneOutreach'?'bg-sky-400':'bg-green-800'}  opacity-75  `}></span>
  <span class={`relative inline-flex rounded-full h-5 w-5 ${pinmarker.evangelismMethod==='oneToOneOutreach'?'bg-sky-400':'bg-green-600'}`}></span>
</span>
         <Chip icon={<FaceIcon />}  color={`${pinmarker.evangelismMethod==='oneToOneOutreach'?'info':'success'}`} label=  {`${pinmarker.numOfPeopleReached} num Of People Reached`}/>
        {/* <div style={{
          backgroundColor: 'white',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#00FF00',
          fontSize: '20px',
          fontWeight: 'bold',
          border: '2px solid #00FF00',
        }}>
          {pinmarker.numOfPeopleSaved}
        </div> */}
      </OverlayViewF>
        </>
      :
              <MarkerF
                key={index}
                position={{
                  lat: parseFloat(pinmarker.location.coordinates[0]),
                  lng: parseFloat(pinmarker.location.coordinates[1]),
                }}
                onClick={() => handleMarkerClick(pinmarker)}
              />
            ))}
            {infoWindowVisible && selectedPosition._id && (
               
               <InfoWindowF
               position={{
                 lat: parseFloat(selectedPosition.location.coordinates[0]),
                 lng: parseFloat(selectedPosition.location.coordinates[1]),
               }}
               onCloseClick={handleInfoWindowClose}
             >
               <div>
                 {/* <RecipeReviewCard data={selectedPosition} /> */}
                 <RecipeReviewCard
           
            data={selectedPosition}
          />
               </div>
             </InfoWindowF>
            )}
            
          </GoogleMap>
        
 </>
  ) : (
    <></>
  );
}

export default React.memo(MyComponent);
